import { render, staticRenderFns } from "./NewsletterSettings.vue?vue&type=template&id=f820ecb0&scoped=true"
import script from "./NewsletterSettings.ts?vue&type=script&lang=js&external"
export * from "./NewsletterSettings.ts?vue&type=script&lang=js&external"
import style0 from "./NewsletterSettings.scss?vue&type=style&index=0&id=f820ecb0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f820ecb0",
  null
  
)

export default component.exports